/**
 * Health probe API — dùng cho status indicator + readiness check + admin
 * components dashboard (P3-F Doc 41).
 */
import { api } from "./client";

export interface HealthResponse {
  status: string;
  service: string;
}

export interface ReadyResponse {
  status: "ready" | "not_ready";
  service: string;
  checks?: Record<string, boolean>;
}

export interface ComponentStatus {
  ok: boolean;
  latency_ms?: number | null;
  detail?: Record<string, unknown> | null;
  error?: string | null;
}

export interface HealthReport {
  ok: boolean;
  components: Record<string, ComponentStatus>;
  checked_at: string;
}

export const healthApi = {
  health: () => api.get<HealthResponse>("/health"),
  ready: () => api.get<ReadyResponse>("/ready"),
  /** Admin-only aggregated component status. */
  components: () => api.get<HealthReport>("/api/v1/admin/health/components"),
};
